import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import {
  APP_FILE_VIEW_OPPORTUNITIES_ROUTE,
  APP_FILE_MANAGE_OPPORTUNITIES_ROUTE,
  APP_FILE_MANAGE_OPPORTUNITIES_ID_ROUTE,
} from "./opportunites.constants";

const ViewOpportunites = Loadable(
  lazy(() =>
    import("./opportunitiesTabs").then(({ OpportunitiesTabs }) => ({
      default: OpportunitiesTabs,
    }))
  )
);

const OpportunitesManage = Loadable(
  lazy(() =>
    import("./ManageOpportunityTabs").then(({ ManageOpportunityTabs }) => ({
      default: ManageOpportunityTabs,
    }))
  )
);

export const OpportunitesRoutes = [
  {
    path: `${APP_FILE_VIEW_OPPORTUNITIES_ROUTE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.OPPORTUNITY]}>
        <ViewOpportunites />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_MANAGE_OPPORTUNITIES_ROUTE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.OPPORTUNITY]}>
        <OpportunitesManage  />
      </AuthorizedRoute>
    ),
  },

  {
    path: `${APP_FILE_MANAGE_OPPORTUNITIES_ID_ROUTE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.OPPORTUNITY]}>
        <OpportunitesManage />
      </AuthorizedRoute>
    ),
  },
];
